import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';

import { DrillingElementColoredCard } from '../../../drilling-element-colored-card';
import { useSortableGhost } from '../../features/sorting/hooks/use-sortable-ghost';
import type { SortableGhostItem } from '../../features/sorting/sortable-ghost-item';
import type { WellRigOperation } from '../../presets/drilling-rigs-chart/entities';
import type { RigsViewSettingsProvider } from '../../presets/drilling-rigs-chart/rigs-view-settings-provider';
import { useMovableElement } from '../../shared/use-movable-element';
import type { Viewport } from '../../shared/viewport/viewport';

import styles from './well-rig-operation-wrapper.module.scss';

interface Props {
  item: SortableGhostItem<WellRigOperation>;
  horizontalViewport: Viewport;
  verticalViewport: Viewport;
  viewSettingsProvider: RigsViewSettingsProvider;
  className?: string;
  cardClassName?: string;
  contentClassName?: string;
  headerClassName?: string;
}

export const GhostWellRigOperationWrapper = observer(function GhostWellRigOperationWrapper({
  item: ghostWrapper,
  horizontalViewport,
  verticalViewport,
  viewSettingsProvider,
  className,
  cardClassName,
  contentClassName,
  headerClassName,
}: Props) {
  const { transform } = useSortableGhost({
    id: ghostWrapper.activeKey,
  });

  const ref = useMovableElement({
    item: ghostWrapper,
    horizontalViewport,
    verticalViewport,
    transform,
  });

  if (!ghostWrapper.options?.isShown) {
    return null;
  }

  const wellIcon = viewSettingsProvider.getWellIcon(ghostWrapper.ghost.data);

  return (
    <div ref={ref} className={clsx(className, styles.dataItem, styles.dragging)}>
      <DrillingElementColoredCard
        title={viewSettingsProvider.getTitle(ghostWrapper.ghost)}
        color={viewSettingsProvider.getWellColor(ghostWrapper.ghost) || ''}
        attributes={viewSettingsProvider.getAttributes(ghostWrapper.ghost)}
        className={clsx(cardClassName, styles.wellCard)}
        contentClassName={contentClassName}
        headerClassName={headerClassName}
      />
    </div>
  );
});
